<template>
  <div class="dict">
    <el-form :model="formData" :rules="rules" ref="formData" label-width="120px">
      <el-collapse v-model="activeNames">
        <!-- 基本信息 -->
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.info') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('applicationCredit.form.creditRequestNo')">
                  <el-input
                    v-model="formData.creditRequestNo"
                    :disabled="true"
                    :placeholder="this.$t('applicationCredit.form.creditRequestNoPlaceholder')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="controlAreaCode"
                  :label="this.$t('applicationCredit.form.businessDepartment')"
                >
                  <treeselect
                    :disabled="canEdit"
                    :options="businessDepartmentList"
                    v-model="formData.controlAreaCode"
                    :defaultExpandLevel="Infinity"
                    openDirection="auto"
                    :clearable="false"
                    :maxHeight="200"
                    :zIndex="2999"
                    :flat="true"
                    :append-to-body="true"
                    @select="(val) => selectNode(val)"
                    :placeholder="$t('company.treeselect.searchIndex')"
                    :searchPromptText="$t('company.treeselect.searchIndex')"
                    :noResultsText="$t('company.treeselect.noData')"
                    :normalizer="normalizer"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="requestPerson"
                  :label="this.$t('applicationCredit.form.requestPerson')"
                >
                  <el-input
                    v-model="formData.requestPersonName"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.requestPersonPlaceholder')"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="requestDate"
                  :label="this.$t('applicationCredit.form.requestDate')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.requestDate"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('applicationCredit.form.requestDatePlaceholder')"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="partnerName"
                  :label="this.$t('applicationCredit.form.partnerName')"
                >
                  <search-table
                    :disabled="canEdit"
                    v-model="formData.partnerName"
                    searchType="partner"
                    :isMultiple="true"
                    :currentValue="formData.partnerName || null"
                    :checkRowKeys="[formData.partnerCode]"
                    @input="setPartner"
                  ></search-table>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="creditCode"
                  :label="this.$t('applicationCredit.form.creditCode')"
                >
                  <el-input
                    v-model="formData.creditCode"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.creditCodePlaceholder')"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="legalPerson"
                  :label="this.$t('applicationCredit.form.legalPerson')"
                >
                  <el-input
                    v-model="formData.legalPerson"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.legalPersonPlaceholder')"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="basicCurrencyType"
                  :label="this.$t('applicationCredit.form.basicCurrencyType')"
                >
                  <el-input
                    style="width: 100%"
                    v-model="formData.basicCurrencyType"
                    :disabled="true"
                    :placeholder="this.$t('applicationCredit.form.basicCurrencyTypePlaceholder')"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="registeredAssets"
                  :label="this.$t('applicationCredit.form.registeredAssets')"
                >
                  <input-number
                    style="width: 100%"
                    v-model="formData.registeredAssets"
                    :disabled="canEdit"
                    :controls="false"
                    :max="99999999999999"
                    :precision="$globalVar.aPoint"
                    :placeholder="this.$t('applicationCredit.form.registeredAssetsPlaceholder')"
                    :clearable="true"
                  >
                  </input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="actualAssets"
                  :label="this.$t('applicationCredit.form.actualAssets')"
                >
                  <input-number
                    style="width: 100%"
                    v-model="formData.actualAssets"
                    :disabled="canEdit"
                    :controls="false"
                    :max="99999999999999"
                    :precision="$globalVar.aPoint"
                    :placeholder="this.$t('applicationCredit.form.actualAssetsPlaceholder')"
                    :clearable="true"
                  >
                  </input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="enterpriseType"
                  :label="this.$t('applicationCredit.form.enterpriseType')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.enterpriseType"
                    :disabled="canEdit"
                    filterable
                    :placeholder="this.$t('applicationCredit.form.enterpriseTypePlaceholder')"
                    clearable
                  >
                    <el-option
                      v-for="item in enterpriseTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="establishedDate"
                  :label="this.$t('applicationCredit.form.establishedDate')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.establishedDate"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('applicationCredit.form.requestDatePlaceholder')"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="streetAddress"
                  :label="this.$t('applicationCredit.form.streetAddress')"
                >
                  <el-input
                    v-model="formData.streetAddress"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.streetAddressPlaceholder')"
                    clearable
                    maxlength="100"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="officeAddress"
                  :label="this.$t('applicationCredit.form.officeAddress')"
                >
                  <el-input
                    v-model="formData.officeAddress"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.officeAddressPlaceholder')"
                    clearable
                    maxlength="100"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- 额度信息 -->
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.accountInfo') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="accountType"
                  :label="this.$t('applicationCredit.form.accountType')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.accountType"
                    :disabled="canEdit"
                    filterable
                    :placeholder="this.$t('applicationCredit.form.accountTypePlaceholder')"
                    clearable
                    @change="changeCreditType"
                  >
                    <el-option
                      v-for="item in accountsTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="creditType"
                  :label="this.$t('applicationCredit.form.creditType')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.creditType"
                    :disabled="canEdit"
                    filterable
                    :placeholder="this.$t('applicationCredit.form.creditTypePlaceholder')"
                    clearable
                  >
                    <el-option
                      v-for="item in creditTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="referenceContractNo"
                  v-if="formData.creditType == 'SX02'"
                  :label="this.$t('applicationCredit.form.referenceContractNo')"
                >
                  <!-- <el-input v-model="formData.referenceContractNo"  :disabled="canEdit "
                                :placeholder='this.$t("applicationCredit.form.referenceContractNoPlaceholder")' clearable maxlength="32">
                            </el-input> -->
                  <SearchModal
                    ref="searchModal"
                    propName="contractNo"
                    propCode="contractNo"
                    className="customer-search"
                    model="referenceContractNo"
                    :placeholder="this.$t('applicationCredit.form.referenceContractNoPlaceholder')"
                    :API="referenceContract.API"
                    :page="true"
                    :columnList="referenceContract.columnList"
                    :extraData="referenceContract.extraData"
                    :isMultiple="false"
                    :currentValue="formData.referenceContractNo"
                    @setSearchModal="setReferenceContract"
                    :disabled="canEdit"
                  ></SearchModal>
                </el-form-item>
                <el-form-item v-else :label="this.$t('applicationCredit.form.referenceContractNo')">
                  <el-input
                    v-model="formData.referenceContractNo"
                    :disabled="true"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="isInsure" :label="this.$t('applicationCredit.form.isInsure')">
                  <el-select
                    style="width: 100%"
                    v-model="formData.isInsure"
                    :disabled="canEdit"
                    filterable
                    :placeholder="this.$t('applicationCredit.form.isInsurePlaceholder')"
                    clearable
                    @change="changeRule"
                  >
                    <el-option
                      v-for="item in isInsureTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="insureAmount"
                  :label="this.$t('applicationCredit.form.insureAmount')"
                >
                  <input-number
                    style="width: 100%"
                    v-model="formData.insureAmount"
                    :disabled="formData.isInsure == 1 ? canEdit : true"
                    :controls="false"
                    :max="99999999999999"
                    :precision="$globalVar.aPoint"
                    :placeholder="this.$t('applicationCredit.form.insureAmountPlaceholder')"
                    :clearable="true"
                  >
                  </input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="requestAmount"
                  :label="this.$t('applicationCredit.form.requestAmount')"
                >
                  <input-number
                    style="width: 100%"
                    v-model="formData.requestAmount"
                    :disabled="canEdit"
                    :controls="false"
                    :max="99999999999999"
                    :precision="$globalVar.aPoint"
                    :placeholder="this.$t('applicationCredit.form.requestAmountPlaceholder')"
                    :clearable="true"
                  >
                  </input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- <el-form-item prop="amountCurrencyType" :label='this.$t("applicationCredit.form.amountCurrencyType")'>
                            <el-input v-model="formData.amountCurrencyType"  :disabled="canEdit"
                                :placeholder='this.$t("applicationCredit.form.amountCurrencyTypePlaceholder")'>
                            </el-input>
                        </el-form-item> -->
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="requestPaymentDays"
                  :label="this.$t('applicationCredit.form.requestPaymentDays')"
                >
                  <input-number
                    style="width: 100%"
                    v-model="formData.requestPaymentDays"
                    :disabled="canEdit"
                    :controls="false"
                    :max="99999999999999"
                    :precision="$globalVar.dPoint"
                    :placeholder="this.$t('applicationCredit.form.requestPaymentDaysPlaceholder')"
                    :cleatable="true"
                  >
                  </input-number>
                  <!-- <el-input v-model="formData.requestPaymentDays"  :disabled="canEdit"
                                    :placeholder='this.$t("applicationCredit.form.requestPaymentDaysPlaceholder")'>
                                </el-input> -->
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="validDate" :label="this.$t('applicationCredit.form.validDate')">
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.validDate"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="pickerStartOptions"
                    :placeholder="this.$t('applicationCredit.form.validDatePlaceholder')"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="invalidDate"
                  :label="this.$t('applicationCredit.form.invalidDate')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.invalidDate"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="pickerEndOptions"
                    :placeholder="this.$t('applicationCredit.form.invalidDatePlaceholder')"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="guaranteeType" :label="'担保方式'">
                  <el-select
                    style="width: 100%"
                    v-model="formData.guaranteeType"
                    :disabled="canEdit"
                    filterable
                    :placeholder="'请选择担保方式'"
                    clearable
                    @change="changeGuaranteeType"
                  >
                    <el-option
                      v-for="item in guaranteeTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="guaranteePerson" :label="'担保人'">
                  <el-input
                    v-model="formData.guaranteePerson"
                    :disabled="canEdit"
                    :placeholder="'请输入担保人'"
                    clearable
                    maxlength="100"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item prop="guarantyDesc" :label="'担保物'">
                  <el-input
                    v-model="formData.guarantyDesc"
                    :disabled="canEdit"
                    :placeholder="'请输入担保物'"
                    clearable
                    maxlength="1024"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item prop="guaranteePurview" :label="'担保范围'">
                  <el-input
                    v-model="formData.guaranteePurview"
                    :disabled="canEdit"
                    :placeholder="'请输入担保范围'"
                    clearable
                    maxlength="1024"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- 上一年度主要财务数据 -->
        <el-collapse-item name="3">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.sellsRevenueInfo') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-tooltip
                  :disabled="!formData.sellsRevenue"
                  class="item"
                  effect="dark"
                  :content="String(formData.sellsRevenue)"
                  placement="top"
                >
                  <el-form-item
                    prop="sellsRevenue"
                    :label="this.$t('applicationCredit.form.sellsRevenue')"
                  >
                    <input-number
                      style="width: 100%"
                      v-model="formData.sellsRevenue"
                      :disabled="canEdit"
                      :placeholder="this.$t('applicationCredit.form.sellsRevenuePlaceholder')"
                      maxlength="32"
                      :clearable="true"
                      :min="-99999999999999"
                      :max="99999999999999"
                      :precision="$globalVar.aPoint"
                    >
                    </input-number>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <el-col :span="6">
                <el-tooltip
                  :disabled="!formData.profit"
                  class="item"
                  effect="dark"
                  :content="String(formData.profit)"
                  placement="top"
                >
                  <el-form-item prop="profit" :label="this.$t('applicationCredit.form.profit')">
                    <!-- <el-input style="width:100%"
                                v-model="formData.profit" :disabled="canEdit"
                                :placeholder='this.$t("applicationCredit.form.profitPlaceholder")'
                                :clearable="true"
                                :maxlength="32"
                               >
                            </el-input> -->
                    <input-number
                      style="width: 100%"
                      v-model="formData.profit"
                      :disabled="canEdit"
                      :placeholder="this.$t('applicationCredit.form.profitPlaceholder')"
                      :clearable="true"
                      maxlength="32"
                      :min="-99999999999999"
                      :max="99999999999999"
                      :precision="$globalVar.aPoint"
                    >
                    </input-number>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <el-col :span="6">
                <el-tooltip
                  :disabled="!formData.totalAssets"
                  class="item"
                  effect="dark"
                  :content="String(formData.totalAssets)"
                  placement="top"
                >
                  <el-form-item
                    prop="totalAssets"
                    :label="this.$t('applicationCredit.form.totalAssets')"
                  >
                    <!-- <el-input style="width:100%"
                                v-model="formData.totalAssets" :disabled="canEdit"
                                :placeholder='this.$t("applicationCredit.form.totalAssetsPlaceholder")'
                                :clearable="true"
                                 :maxlength="32"
                                >
                            </el-input> -->
                    <input-number
                      style="width: 100%"
                      v-model="formData.totalAssets"
                      :disabled="canEdit"
                      :placeholder="this.$t('applicationCredit.form.totalAssetsPlaceholder')"
                      :clearable="true"
                      maxlength="32"
                      :min="-99999999999999"
                      :max="99999999999999"
                      :precision="$globalVar.aPoint"
                    >
                    </input-number>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <el-col :span="6">
                <el-tooltip
                  :disabled="!formData.totalDebt"
                  class="item"
                  effect="dark"
                  :content="String(formData.totalDebt)"
                  placement="top"
                >
                  <el-form-item
                    prop="totalDebt"
                    :label="this.$t('applicationCredit.form.totalDebt')"
                  >
                    <!-- <el-input style="width:100%"
                                v-model="formData.totalDebt" :disabled="canEdit"
                                 :maxlength="32"
                                :clearable="true"
                                :placeholder='this.$t("applicationCredit.form.totalDebtPlaceholder")'>
                            </el-input> -->
                    <input-number
                      style="width: 100%"
                      v-model="formData.totalDebt"
                      :disabled="canEdit"
                      maxlength="32"
                      :clearable="true"
                      :placeholder="this.$t('applicationCredit.form.totalDebtPlaceholder')"
                      :min="-99999999999999"
                      :max="99999999999999"
                      :precision="$globalVar.aPoint"
                    >
                    </input-number>
                  </el-form-item>
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-tooltip
                  :disabled="!formData.totalPureAssets"
                  class="item"
                  effect="dark"
                  :content="String(formData.totalPureAssets)"
                  placement="top"
                >
                  <el-form-item
                    prop="totalPureAssets"
                    :label="this.$t('applicationCredit.form.totalPureAssets')"
                  >
                    <!-- <el-input style="width:100%"
                                v-model="formData.totalPureAssets" :disabled="canEdit"
                                :maxlength="32"
                                :clearable="true"
                                :placeholder='this.$t("applicationCredit.form.totalPureAssetsPlaceholder")'>
                            </el-input> -->
                    <input-number
                      style="width: 100%"
                      v-model="formData.totalPureAssets"
                      :disabled="canEdit"
                      maxlength="32"
                      :clearable="true"
                      :placeholder="this.$t('applicationCredit.form.totalPureAssetsPlaceholder')"
                      :min="-99999999999999"
                      :max="99999999999999"
                      :precision="$globalVar.aPoint"
                    >
                    </input-number>
                  </el-form-item>
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="lastYearFinanceMark"
                  :label="this.$t('applicationCredit.form.lastYearFinanceMark')"
                >
                  <el-input
                    v-model="formData.lastYearFinanceMark"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.lastYearFinanceMarkPlaceholder')"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- 企业基本情况 -->
        <el-collapse-item name="4">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.enterpriseInfo') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="shareholderStructure"
                  :label="this.$t('applicationCredit.form.shareholderStructure')"
                >
                  <el-input
                    v-model="formData.shareholderStructure"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.shareholderStructurePlaceholder')"
                    clearable
                    maxlength="200"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="enterpriseProperty"
                  :label="this.$t('applicationCredit.form.enterpriseProperty')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.enterpriseProperty"
                    :multiple="true"
                    :disabled="canEdit"
                    filterable
                    :placeholder="this.$t('applicationCredit.form.enterprisePropertyPlaceholder')"
                    clearable
                  >
                    <el-option
                      v-for="item in enterprisePropertyList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="upstreamAndPayment"
                  class="propClass"
                  :label="this.$t('applicationCredit.form.upstreamAndPayment')"
                >
                  <el-input
                    v-model="formData.upstreamAndPayment"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.upstreamAndPaymentPlaceholder')"
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="downstreamAndPayment"
                  class="propClass"
                  :label="this.$t('applicationCredit.form.downstreamAndPayment')"
                >
                  <el-input
                    v-model="formData.downstreamAndPayment"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.upstreamAndPaymentPlaceholder')"
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--<el-row>-->
            <!--    <el-col :span="6">-->
            <!--        <el-form-item prop="assetType" :label='this.$t("applicationCredit.form.assetType")'>-->
            <!--            <el-select style="width:100%" v-model="formData.assetType" :multiple="false" :disabled="canEdit" filterable-->
            <!--                :placeholder='this.$t("applicationCredit.form.assetTypePlaceholder")' clearable>-->
            <!--                <el-option-->
            <!--                    v-for="item in assetTypeList"-->
            <!--                    :key="item.value"-->
            <!--                    :label="item.label"-->
            <!--                    :value="item.value">-->
            <!--                    </el-option>-->
            <!--            </el-select>-->
            <!--        </el-form-item>-->
            <!--    </el-col>-->
            <!--    <el-col :span="18">-->
            <!--        <el-form-item prop="assetTypeDesc" class="propClass" :label='this.$t("applicationCredit.form.assetTypeDesc")'>-->
            <!--            <el-input v-model="formData.assetTypeDesc"  :disabled="canEdit"-->
            <!--                :placeholder='this.$t("applicationCredit.form.assetTypeDescPlaceholder")'-->
            <!--                type="textarea"-->
            <!--                :rows="3"-->
            <!--                clearable-->
            <!--                maxlength="256">-->
            <!--            </el-input>-->
            <!--        </el-form-item>-->
            <!--    </el-col>-->
            <!--</el-row>-->
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="tradingModel"
                  :label="this.$t('applicationCredit.form.tradingModel')"
                >
                  <el-input
                    v-model="formData.tradingModel"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.tradingModelPlaceholder')"
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="businessRiskJudgement"
                  :label="this.$t('applicationCredit.form.businessRiskJudgement')"
                >
                  <el-input
                    v-model="formData.businessRiskJudgement"
                    :disabled="canEdit"
                    :placeholder="
                      this.$t('applicationCredit.form.businessRiskJudgementPlaceholder')
                    "
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  prop="enterpriseOther"
                  :label="this.$t('applicationCredit.form.enterpriseOther')"
                >
                  <el-input
                    v-model="formData.enterpriseOther"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.enterpriseOtherPlaceholder')"
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <!-- 申请原因 -->
        <el-collapse-item name="5">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.requestReason') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row :gutter="24">
              <el-col>
                <el-form-item prop="requestReason" label=" ">
                  <el-input
                    v-model="formData.requestReason"
                    :disabled="canEdit"
                    :placeholder="this.$t('applicationCredit.form.requestReasonPlaceholder')"
                    type="textarea"
                    :rows="3"
                    clearable
                    :maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <el-collapse v-model="activeNames" class="collapse-last-content">
      <!-- 申请单附件上传 -->
      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('applicationCredit.form.attachmentList') }}</div
          >
        </template>
        <div class="collapse-content">
          <upload
            ref="upload"
            @upload="uploadList"
            v-bind:tableData="attachmentList"
            v-bind:isShow="isEdit"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-form :model="formData" ref="form" label-width="120px">
      <el-collapse v-model="activeNames" class="collapse-main-content collapse-last-content">
        <!-- 风控复核信息 -->
        <el-collapse-item name="7">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.riskManageInfo') }}</div
            >
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item
                  class="propClass"
                  :label="this.$t('applicationCredit.form.isInformationMatch')"
                >
                  <el-input
                    v-model="formData.isInformationMatch"
                    :disabled="true"
                    placeholder=""
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  class="propClass"
                  :label="this.$t('applicationCredit.form.hasPoorCredit')"
                >
                  <el-input
                    v-model="formData.hasPoorCredit"
                    :disabled="true"
                    clearable
                    placeholder=""
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('applicationCredit.form.firstTradeDate')">
                  <el-input
                    v-model="formData.firstTradeDate"
                    :disabled="true"
                    clearable
                    placeholder=""
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('applicationCredit.form.totalTradeTimes')">
                  <el-input
                    v-model="formData.totalTradeTimes"
                    :disabled="true"
                    clearable
                    placeholder=""
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('applicationCredit.form.lastRequestAmount')">
                  <el-input
                    v-model="formData.lastRequestAmount"
                    :disabled="true"
                    clearable
                    placeholder=""
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('applicationCredit.form.lastRequestPaymentDays')">
                  <el-input
                    v-model="formData.lastRequestPaymentDays"
                    :disabled="true"
                    clearable
                    placeholder=""
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('applicationCredit.form.isOvertimeAgreement')">
                  <el-input
                    v-model="formData.isOvertimeAgreement"
                    :disabled="true"
                    clearable
                    placeholder=""
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('applicationCredit.form.cooperationAmount')">
                  <el-input
                    v-model="formData.cooperationAmount"
                    :disabled="true"
                    clearable
                    placeholder=""
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="this.$t('applicationCredit.form.majorLawsuits')">
                  <el-input
                    v-model="formData.majorLawsuits"
                    :disabled="true"
                    placeholder=""
                    clearable
                    type="textarea"
                    :rows="3"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="this.$t('applicationCredit.form.riskManageOther')">
                  <el-input
                    v-model="formData.riskManageOther"
                    :disabled="true"
                    clearable
                    placeholder=""
                    type="textarea"
                    :rows="3"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div class="fixed-bottom-btnList" v-if="!canEdit">
      <el-button
        type="primary"
        v-hasPermi="['2021042916085774173']"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        type="primary"
        v-hasPermi="['2021042916091719042']"
        @click="commit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.commit') }}</el-button
      >
    </div>
    <div class="fixed-bottom-btnList" v-if="canEdit">
      <el-button
        type="primary"
        v-hasPermi="['2021042916093682652']"
        @click="edit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.edit') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import SearchTable from '@/components/form-item/search-table';
  import API from '@/api/purchaseSalesCenter/credit/applicationCredit.js';
  import InputNumber from '@/components/form-item/input-number';
  import DataBaseAPI from '@/api/dataBase';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  import upload from '@/components/upload';
  import formRules from './rules/rules';
  export default {
    components: {
      SearchModal,
      SearchTable,
      upload,
      InputNumber,
    },
    name: 'applicationCreditBaseEdit',
    data() {
      let routeQuery = this.$route.query;
      let newDate = new Date();
      let date = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
      let canEdit = routeQuery.canEdit == '0' ? true : false;
      return {
        isInsureTypeList: [
          { value: 0, label: this.$t('applicationCredit.msg.no') },
          { value: 1, label: this.$t('applicationCredit.msg.yes') },
        ],
        canEdit: canEdit,
        isEdit: !canEdit,
        load: false,
        attachmentList: [], //附件列表
        activeNames: ['1', '2', '3', '4', '5', '6', '7'], //默认展开那些面板，
        formData: {
          creditRequestNo: null, //申请单号
          businessDepartmentName: null, //事业部门
          requestPersonName: null, //申请人
          requestDate: date, //申请时间
          partnerNo: routeQuery.partnerCode || null, //合作伙伴编码
          partnerName: routeQuery.partnerZhName || null, //合作伙伴名称
          creditCode: routeQuery.creditCode || null, //统一社会信用代码
          legalPerson: routeQuery.legalPerson || null, //法人
          registeredAssets: routeQuery.registeredAssets || 0, //注册资本（万）
          actualAssets: routeQuery.actualAssets || null, //实收资本（万）
          basicCurrencyType: routeQuery.tradeCurrency || 'CNY', //基本信息币别
          establishedDate: routeQuery.establishedDate, //成立时间
          enterpriseType: routeQuery.enterpriseType || null, //企业类型
          streetAddress: routeQuery.streetAddress || null, //街道地址
          officeAddress: routeQuery.officeAddress || null, //办公地址
          partnerType: routeQuery.partnerType || null,
          requestStatus: '',
        },
        enterpriseTypeList: [], //企业类型
        businessDepartmentList: [], //事业部门下拉列表
        enterprisePropertyList: [], //企业类型下拉列表
        assetTypeList: [], //资产类别下拉列表
        requestStatusList: [], //申请状态下拉列表
        creditTypeList: [], //授信类型下拉列表
        accountsTypeList: [], //账款类型下拉列表
        guaranteeTypeList: [], //担保方式下拉列表
        pickerStartOptions: {
          disabledDate: (time) => {
            let endDate = this.formData.invalidDate;
            if (endDate) {
              return time.getTime() > new Date(endDate).getTime();
            }
          },
        },
        pickerEndOptions: {
          disabledDate: (time) => {
            let startDate = this.formData.validDate;
            if (startDate) {
              return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
            }
          },
        },
        rules: formRules.formRules,
        normalizer(node) {
          //只能选择根节点
          if (node.children) {
            node.children.map((item) => {
              item['isDisabled'] = true;
            });
          }
          return node;
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //关联合同号
      referenceContract() {
        return {
          API: API.CONTRACT_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            listStatus: ['ZT06', 'ZT02'],
            partnerCode: this.formData.partnerNo,
          },
          columnList: [
            { prop: 'contractNo', label: window.vm.$t('applicationCredit.table.contractNo') },
            {
              prop: 'contractStatusName',
              label: window.vm.$t('applicationCredit.table.requestStatus'),
            },
          ],
        };
      },
    },
    mounted() {
      this.creditRequestNo = this.$route.query.creditRequestNo || null;
      this.id = this.$route.query.id || null;
      if (this.creditRequestNo) {
        this.getData();
      }
      this.formData.requestPersonName = this.userInfo.userInfo.userName;
      // this.formData.businessDepartmentName = this.userInfo.userInfo.departmentName
      // this.formData.businessDepartmentCode = this.userInfo.userInfo.departmentCode
      this.getDic();
      this.initDepartment();
      if (this.formData.isInsure == 1) {
        this.rules.insureAmount[0].required = true;
      } else {
        this.rules.insureAmount[0].required = false;
        this.$refs.formData.clearValidate(['insureAmount']);
      }
      if (this.formData.guaranteeType == 3 || this.formData.guaranteeType == 2) {
        this.rules.guarantyDesc[0].required = true;
      } else {
        this.rules.guarantyDesc[0].required = false;
        this.$refs.formData.clearValidate(['guarantyDesc']);
      }
    },
    methods: {
      //选择合作伙伴
      setPartner(value) {
        if (value) {
          this.formData.partnerNo = value[0].partnerCode;
          this.formData.partnerName = value[0].partnerZhName;
          this.formData.partnerType = value[0].partnerType;
          this.formData.creditCode = value[0].creditCode || this.formData.creditCode;
          this.formData.legalPerson = value[0].legalPerson || this.formData.legalPerson;
          this.formData.registeredAssets =
            value[0].registeredAssets || this.formData.registeredAssets;
          this.formData.actualAssets = value[0].actualAssets || this.formData.actualAssets;
          this.formData.enterpriseType = value[0].enterpriseType || this.formData.enterpriseType;
          this.formData.establishedDate = value[0].establishedDate || this.formData.establishedDate;
          this.formData.streetAddress = value[0].streetAddress || this.formData.streetAddress;
          this.formData.officeAddress = value[0].officeAddress || this.formData.officeAddress;
          //this.formData.basicCurrencyType = value[0].tradeCurrency||this.formData.basicCurrencyType
        } else {
          this.formData.partnerNo = '';
          this.formData.partnerName = '';
          this.formData.partnerType = '';
          this.formData.creditCode = '';
          this.formData.legalPerson = '';
          this.formData.registeredAssets = '';
          this.formData.actualAssets = '';
          this.formData.enterpriseType = '';
          this.formData.establishedDate = '';
          this.formData.streetAddress = '';
          this.formData.officeAddress = '';
        }
        this.formData.referenceContractNo = '';
        this.$nextTick(() => {
          this.$refs.formData.clearValidate();
        });
      },
      //事业部门
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
          treeFlag: 1,
          currentStatus: '0',
        };
        this.$axios.post(DataBaseAPI.LIST_CONTROL_AREA_DEPARTMENT_API, params).then((res) => {
          if (0 == res.data.code && res.data.data && res.data.data.length > 0) {
            this.businessDepartmentList = res.data.data;
            this.getSelectedNode(this.businessDepartmentList, this.businessDepartmentList);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //获取详情
      getData() {
        this.$axios.get(API.UPDATE_APPLICATION_CREDIT_API + this.creditRequestNo).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            res.data.data.enterpriseProperty = res.data.data.enterpriseProperty
              ? res.data.data.enterpriseProperty.split(',')
              : [];
            this.formData = res.data.data;
            if (res.data.data.attachmentList) {
              this.attachmentList = res.data.data.attachmentList;
            }
            this.$nextTick(() => {
              if (this.formData.guaranteeType == 3 || this.formData.guaranteeType == 2) {
                this.rules.guarantyDesc[0].required = true;
              } else {
                this.rules.guarantyDesc[0].required = false;
                this.$refs.formData.clearValidate(['guarantyDesc']);
              }
              this.$refs.formData.clearValidate();
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //修改
      edit() {
        if (!(this.formData.requestStatus == 'ZT06' || this.formData.requestStatus == 'ZT05')) {
          this.$message({
            showClose: true,
            message: this.$t('applicationCredit.msg.typeSelectEdit'),
            type: 'error',
          });
        } else {
          let path = {
            fromPath: {
              path: '/credit/applicationDetail',
              name: 'applicationCreditBaseEdit',
              meta: {
                keepAlive: true,
                title: this.$t('applicationCredit.msg.applicationCreditBaseEdit'),
              },
            },
            toPath: {
              path: '/credit/applicationCreditEdit',
              name: 'applicationCreditEdit',
              meta: {
                keepAlive: true,
                title: this.$t('applicationCredit.msg.applicationCreditEdit'),
              },
              query: { creditRequestNo: this.creditRequestNo, id: this.id, canEdit: '1' },
            },
          };
          this.$store.dispatch('tagsView/backTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path.toPath);
            });
          });
        }
      },
      changeRule(val) {
        if (val == 1) {
          this.rules.insureAmount[0].required = true;
        } else {
          this.rules.insureAmount[0].required = false;
          this.$refs.formData.clearValidate(['insureAmount']);
        }
      },
      //若担保方式为抵押／质押的情况则担保物必填
      changeGuaranteeType(val) {
        if (val == 3 || val == 2) {
          this.rules.guarantyDesc[0].required = true;
        } else {
          this.rules.guarantyDesc[0].required = false;
          this.$refs.formData.clearValidate(['guarantyDesc']);
        }
      },
      //选择部门
      selectNode(val) {
        this.formData.controlAreaCode = val.id;
        this.formData.controlAreaName = val.label;
      },
      //选择关联合同号-临时
      setReferenceContract(prop, val) {
        const contractList = [];
        val.map((item) => {
          contractList.push(item.contractNo);
        });
        this.formData.referenceContractNo = contractList.join(',');
      },
      changeCreditType(val) {
        if (val == 'SX01' || !val) {
          this.formData.referenceContractNo = '';
        }
      },
      //获取字典值
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //企业类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'enterprise_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.enterpriseTypeList = res.data.data;
            }
          });
        //企业性质
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'business_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.enterprisePropertyList = res.data.data;
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'credit_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.creditTypeList = res.data.data;
            }
          });
        //账款类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'account_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.accountsTypeList = res.data.data;
            }
          });
        //账款类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'guarantee_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.guaranteeTypeList = res.data.data;
            }
          });
        //资产类别
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'asset_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.assetTypeList = res.data.data;
            }
          });
      },
      //保存/提交
      save() {
        this.saveData(0);
      },
      //提交
      commit() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.saveData(1);
          }
        });
      },
      //调用保存方法
      saveData(type) {
        this.load = true;
        this.loading.startLoading();
        let data = this.formData;
        data.type = type;
        if (this.id) {
          data.id = this.id;
        }
        if (this.creditRequestNo) {
          data.creditRequestNo = this.creditRequestNo;
        }
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        //let attachmentList = this.$refs.upload.getVal()
        data.attachmentList = JSON.stringify(this.attachmentList);
        data.enterpriseProperty = data.enterpriseProperty ? data.enterpriseProperty.toString() : '';
        let url = type == 1 ? API.SUBMIT_APPLICATION_CREDIT_API : API.ADD_APPLICATION_CREDIT_API;
        this.$axios
          .post(url, data)
          .then((res) => {
            if (0 == res.data.code) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              if (type == 0) {
                if (this.$route.name == 'applicationCreditAdd') {
                  this.dblclickEvent(res.data.data);
                } else {
                  this.getData();
                }
              } else {
                this.gotoList(this.$route.name);
              }
            } else {
              if (type == 1 && res.data.data && res.data.data.id) {
                if (this.$route.name == 'applicationCreditAdd') {
                  this.dblclickEvent(res.data.data);
                } else {
                  this.getData();
                }
              }
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .then(() => {
            this.load = false;
            this.loading.endLoading();
          });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/credit/applicationAdd',
            name: 'applicationCreditAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/credit/applicationCreditEdit',
            name: 'applicationCreditEdit',
            meta: {
              keepAlive: false,
            },
            query: {
              creditRequestNo: value.creditRequestNo,
              id: value.id,
              canEdit: '1',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //跳转到列表页面
      gotoList(name) {
        name = name == 'applicationCreditAdd' ? 'applicationAdd' : name;
        let path = {
          fromPath: {
            path: `/credit/${name}`,
            name: name,
            meta: {
              keepAlive: true,
              title: this.$t(`applicationCredit.msg.${name}`),
            },
          },
          toPath: {
            path: '/credit/applicationList',
            name: 'applicationCreditList',
            meta: {
              keepAlive: false,
              title: this.$t('applicationCredit.msg.listCreditRequests'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //更新附件列表
      uploadList(value) {
        this.attachmentList = value;
      },
    },
    watch: {},
  };
</script>
<style lang="scss" scoped>
  .collapse-last-content {
    margin-top: 10px;
  }
</style>
